export const SET_WISHLIST_ITEMS = 'SET_WISHLIST_ITEMS';
export const ADD_WISHLIST_ITEM = 'ADD_WISHLIST_ITEM';
export const DELETE_WISHLIST_ITEM = 'DELETE_WISHLIST_ITEM';